import { AxiosPromise } from 'axios'
import { http } from '../http/http'
import qs from 'qs'

export enum NotificationSourceModule {
    PICTURE_MANAGMENT = 'pm',
    STORE_VISIT = 'svt',
    COMMUNICATION = 'communication',
}

/**
 * @export NotificationsApi - Just an api interface for claiming notifications data and reducing the code needed for axios http functions
 * @class NotificationsApi
 */
export class NotificationsApi {
    /**
     * Base Url for User Api
     * @static
     * @type {string}
     * @memberof NotificationsApi
     */
    static USER_BASE_URL: string = process.env.SMARTLY_BASE_URL_BE

    /**
     * Endpoint for user info
     * @static
     * @type {string}
     * @memberof NotificationsApi
     */
    static NOTIFICATIONS_LIST: string = '/notificationsapi/notifications'

    static getApiUrl(
        url: string,
        baseUrl: string = NotificationsApi.USER_BASE_URL
    ) {
        return `${baseUrl}${url}`
    }

    /**
     * This functions get notifications count
     * @returns Promise of type AxiosPromise
     */
    static getNotificationsCount = async (
        params: any,
        baseUrl?: string
    ): Promise<AxiosPromise<any>> => {
        return http.get<any>(
            NotificationsApi.getApiUrl(
                NotificationsApi.NOTIFICATIONS_LIST,
                baseUrl
            ),
            {
                params: {
                    is_read: false,
                    no_data: true,
                    ...params,
                },
                paramsSerializer: (params) =>
                    qs.stringify(params, { arrayFormat: 'repeat' }),
            }
        )
        // try {
        //     let response = await http.get<any>(
        //         NotificationsApi.getApiUrl(NotificationsApi.NOTIFICATIONS_LIST, baseUrl)
        //     )
        //     return response
        // } catch (error) {
        //     throw error
        // }
    }
}

export interface IResponseNotifications {
    count: number
}
